var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":_vm.landing,"width":"800px"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }